import { fetch } from '@/utils/http'

export default {
  //获取预言机列表
  getOracleList: params => fetch('get', '/cbaas-service/v1/oracleManagement/getOracleList', params),

  //创建预言机
  createOraclet: params => fetch('post', '/cbaas-service/v1/oracleManagement/createOracle', params),

  //下载预言机
  downloadOracle: params =>
    fetch('post', '/cbaas-service/v1/oracleManagement/downloadOracle', params),

  //订阅预言机
  subscribeOracle: params =>
    fetch('post', '/cbaas-service/v1/oracleManagement/subscribeOracle', params),

  //删除预言机
  deleteOracle: params =>
    fetch(
      'delete',
      `/cbaas-service/v1/oracleManagement/deleteOracle?oracleID=${params.oracleID}`,
      params
    ),

  //安装部署合约
  installDefaultContract: params =>
    fetch(
      'put',
      `/cbaas-service/v1/oracleManagement/installDefaultContract?ContractType=${params.ContractType}&ChainID=${params.ChainID}&OracleID=${params.OracleID}`,
      params
    )
}
